<template>
  <div :class="$style.box">
    <div :class="$style.content">
      <img :src="bg" alt="" />
      <div :class="$style.bg"></div>
      <div :class="$style.inner">
        <p v-if="isWX">尊敬的{{ userInfo.nickname }}：</p>

        <!-- 微信中：未绑定手机号 -->
        <div v-if="isWX && userInfo.tel_status == 0">
          <p>
            为了您有更好的游戏体验，<span
              >跳转升级链接前，需要您先绑定一下手机。</span
            >
          </p>
          <p>绑定手机后，您可以在升级后的客户端里登录现在小程序中的游戏角色</p>
        </div>

        <!-- 微信中：已绑定手机号 -->
        <div v-if="isWX && userInfo.tel_status == 1">
          <p>
            <span
              >您已成功绑定了手机号！<br />
              绑定的手机号为：{{ userInfo.tel_num }}</span
            >
          </p>
          <p>您可以在升级后的客户端里登录现在小程序中的游戏角色。</p>
        </div>

        <!-- 非微信 -->
        <p v-if="!isWX">您可以在升级后的客户端里登录现在小程序中的游戏角色。</p>

        <img :src="bindBg" alt="" />
        <p v-if="isWX">
          在客户端中，您可使用游戏账号登录，也可以使用绑定的手机号进行登录，游戏密码您可在下方自定义设置。
        </p>
        <p v-else>
          在客户端中，您可使用游戏账号登录，也可以使用绑定的手机号进行登录。
        </p>
        <p :class="$style.bot">
          如有任何问题，请联系<span @click="openKF">【人工客服】</span>
        </p>
        <!-- 微信中：表单部分 - 未绑定 -->
        <div v-if="isWX && userInfo.tel_status == 0">
          <Field
            :class="$style.field"
            :type="1"
            :placeholder="'手机号：'"
            :icon="phoneIcon"
            v-model.trim="formData.phone"
          ></Field>
          <Field
            :class="$style.field"
            :type="3"
            :placeholder="'验证码：'"
            :icon="codeIcon"
            :phone="formData.phone"
            v-model.trim="formData.code"
          ></Field>
          <Field
            :class="$style.field"
            :type="2"
            :placeholder="'游戏密码：6-18位数字字母组合'"
            :icon="passIcon"
            v-model.trim="formData.password"
          ></Field>
          <div :class="$style.submit" @click="submit">提交并前往下载</div>
        </div>
        <!-- 微信中：表单部分 - 已绑定 -->
        <div
          v-if="isWX && userInfo.tel_status != 0"
          :class="$style.submit"
          @click="openDialog"
        >
          前往下载
        </div>
        <!-- 非微信：直接下载 -->
        <a
          ref="download"
          :href="apkURL"
          target="_blank"
          v-if="!isWX"
          :class="$style.submitA"
          >前往下载</a
        >
      </div>
    </div>
    <!-- 微信中：绑定成功弹窗 -->
    <div :class="$style.dialog" v-show="isWX && dialogShow" @touchmove.prevent>
      <div>
        <p>
          您的游戏账号为：<span>{{ userInfo.user_name }}</span
          ><br />您绑定手机号为：<span>{{
            userInfo.tel_num == "" ? bindPhone : userInfo.tel_num
          }}</span
          ><br />
        </p>
        <p v-if="bindPass != ''">
          您的游戏密码为：<span>{{ bindPass }}</span>
        </p>
        <p :class="$style.turn"></p>
        <p :class="$style.turn">
          您可以<span :class="$style.bold">自行截图保存</span
          >当前的账号信息，升级后，您可在客户端使用游戏账号或绑定的手机号进行登录。
        </p>
        <img :src="dialogBg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import Field from "./components/Field.vue";
import { CDN_URL } from "@/config";
import { regList } from "./config";
import { Toast } from "vant";
import { mapState } from "vuex";
import { getURL } from "@/apis/gameJump";

export default {
  components: { Field },
  data() {
    return {
      bg: `${CDN_URL}/wxact/game-bg.png`, // 背景小猫图片
      bindBg: `${CDN_URL}/wxact/game-pic.png`, // 绑定示意图
      dialogBg: `${CDN_URL}/wxact/game-open.png`, // 打开浏览器示意图
      phoneIcon: `${CDN_URL}/wxact/game-phone.png`, // 手机号ICON
      codeIcon: `${CDN_URL}/wxact/game-code.png`, // 验证码ICON
      passIcon: `${CDN_URL}/wxact/game-pass.png`, // 密码ICON
      formData: {
        phone: "", // 手机号
        code: "", // 验证码
        password: "", // 密码
      },
      isWX: false, // 是否为微信内置浏览器
      dialogShow: false, // 绑定完成弹窗显示
      bindPass: "", // 绑定密码 只有初次提交表单回显
      bindPhone: "", // 绑定手机号 用于初次提交回显
      apkURL: "", // 游戏下载链接
    };
  },
  async created() {
    await this.getURL();
    this.isWeiXin();
  },
  computed: {
    ...mapState("gamejump", {
      userInfo: "userInfo",
    }),
  },
  methods: {
    // 判断是否为微信浏览器
    isWeiXin() {
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.isWX = true;
      } else {
        this.isWX = false;
        setTimeout(() => {
          this.$refs.download.click();
        }, 100);
      }
    },
    // 非微信浏览器获取下载链接
    async getURL() {
      const { ret, content } = await getURL({
        appkey: this.$route.query.appkey || 0,
        type: this.$route.query.type || '',
      });
      if (ret === 1) {
        this.apkURL = content.apk_url;
      }
    },
    // 点击提交
    async submit() {
      const { phone, verification, password } = regList;
      const phoneReg = new RegExp(phone);
      const codeReg = new RegExp(verification);
      const passReg = new RegExp(password);
      console.log(this.formData);
      if (!phoneReg.test(this.formData.phone)) {
        Toast.fail("手机号有误，请检查后重新填写");
        return;
      }
      if (!codeReg.test(this.formData.code)) {
        Toast.fail("验证码有误，请检查后重新填写");
        return;
      }
      if (!passReg.test(this.formData.password)) {
        Toast.fail("密码应为6-18位数字字母组合");
        return;
      }
      const r = await this.$store.dispatch("gamejump/userBind", this.formData);
      if (r) {
        Toast.success("绑定成功");
        this.bindPass = this.formData.password;
        this.bindPhone = this.formData.phone;
        this.openDialog();
      }
    },
    // 点击前往下载 - 微信中 - 显示打开浏览器弹窗
    openDialog() {
      this.dialogShow = true;
    },
    // 点击人工客服
    openKF() {
      window.open("https://h5.hzwxbz2.cn/v2/h5/manualCustomer#", "_self");
    },
  },
};
</script>

<style lang="scss" module>
.box {
  width: 100%;
  height: auto;
  background-color: #ddac69;
  padding-top: 10px;
  .content {
    width: 356px;
    height: 900px;
    margin: 0px auto;
    position: relative;
    > img {
      width: 175px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      z-index: 2;
    }
    .bg {
      width: 100%;
      height: 791px;
      background: #ffffff;
      border-radius: 8px;
      position: absolute;
      top: 70px;
      z-index: 1;
    }
    .inner {
      width: 322px;
      min-height: 200px;
      // background-color: pink;
      position: absolute;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #b2b2b2;
      line-height: 22px;
      z-index: 3;
      left: 19px;
      top: 120px;
      p {
        margin-bottom: 15px;
        > span {
          color: #cfa668;
        }
      }
      .bot {
        margin-bottom: 30px;
      }
      > img {
        width: 322px;
        margin-bottom: 15px;
      }
      .field {
        width: 271px;
        height: 39px;
        margin: 0px auto 15px auto;
      }
      .submit,
      .submitA {
        width: 211px;
        height: 42px;
        background: #daac63;
        border-radius: 21px;
        margin: 41px auto 0px auto;
        line-height: 42px;
        text-align: center;
        font-size: 19px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #ffffff;
      }
      .submitA {
        display: block;
      }
    }
  }
  .dialog {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: #ddac69;
    z-index: 4;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #b2b2b2;
    line-height: 22px;
    > div {
      width: 356px;
      height: 90%;
      margin: 10px auto 0px auto;
      background-color: #fff;
      border-radius: 8px;
      padding: 14px;
      .turn {
        margin-bottom: 15px;
      }
      p {
        > span {
          color: #cfa668;
        }
        .bold {
          font-weight: bold;
        }
      }
      > img {
        width: 100%;
      }
    }
  }
}
</style>